import React, { useEffect, useRef } from 'react'
import { IPosition } from '../dto/IPosition';
import { SelectorService } from '../services/SelectorService';
import * as Responsiveness from '../modules/ui/responsiveness';
import { trapFocus } from '../modules/focusTrap';

interface INoteTooltipProps {
    onAddMarker:() => void;
    onAddNote:() => void;
    onClose:() => void;
    position:IPosition;
    visible:boolean;
    disableNotes:boolean;
    hideTools: boolean;
}

function NoteTooltip(props: INoteTooltipProps) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!props.visible || !container) {
            return;
        }

        const cleanupTrap = trapFocus(container);

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                props.onClose();
                document.getElementById('documentcontent')?.focus();
            }
        };
        container.addEventListener('keydown', handleKeyDown);

        return () => {
            cleanupTrap?.();
            container.removeEventListener('keydown', handleKeyDown);
        };
    }, [props.visible]);

    const handlePrint = (event) => {
        event.preventDefault();
        const selection = SelectorService.instance.getDocumentSelection();
        (window as any)._printContent(selection.text, selection.chapter);
    }

    const handleNote = (event) => {
        event.preventDefault();
        if(!props.disableNotes) {
            props.onAddNote();
        }
    }

    const handleMarker = (event) => {
        event.preventDefault();
        if(!props.disableNotes) {
            props.onAddMarker();
        }
    }

    const openLogin = (e) => {
        e.preventDefault();
        $("#loginButtonHidden")[0].click();
    };

    if(!props.visible) {
        return null;
    }

    if(Responsiveness.smallerThan(Responsiveness.TABLET_LANDSCAPE)) {
        return null;
    }

    const examModeContainer = document.getElementById("exam-mode-container");
    let examModeContent: string | null = null;

    if (examModeContainer && !examModeContainer.classList.contains("exam-mode-container_consultant")) {
        examModeContent = examModeContainer.innerHTML;
    }

    const { position: { x, y } } = props;
    const newY = y + 50;
    const tooltipStyle = { top: Math.round(newY), left: Math.round(x) };

    return (
        <div ref={containerRef} className={`tooltip ${props.disableNotes ? "tooltip--note-actions-disabled" : ""}`} style={tooltipStyle}>
            <div className="tooltip__inner-wrapper">
                <div className="tooltip__actions">
                    <button className="tooltip__action tooltip__action--print" onClick={handlePrint}>
                        Skriv ut
                    </button>

                    {examModeContent && (
                        <div className="vma__exam-mode vma__exam-mode-toolip">
                            <span className="vma__exam-mode-toolip-header">Revisorsexamensläge är på.</span> Avaktivera för att kunna lägga till anteckningar och markera text.
                        </div>
                    )}

                    {!examModeContent && (
                        props.disableNotes && !props.hideTools ? (
                            <div className="tooltip__info-ip">
                                <p>Logga in med ditt personliga konto för att kunna lägga till anteckningar och markera text. <a href="" onClick={openLogin}>Logga in →</a></p>
                            </div>
                        ): (
                            <>
                                <button className={`tooltip__action ${props.hideTools ? "tooltip__action-disabled" : ""}`} onClick={handleNote} disabled={props.disableNotes}>
                                    <div className="tooltip__action--addNote"/>
                                    Lägg till anteckning
                                </button>

                                <button className={`tooltip__action tooltip__action--pen ${props.hideTools ? "tooltip__action-disabled" : ""}`} onClick={handleMarker} disabled={props.disableNotes}>
                                    Markera text
                                </button>
                            </>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

export default NoteTooltip
